// Job status from GET /projects/bulk-create-financial-year/status/:jobId
export type JobStatus = 'pending' | 'processing' | 'completed' | 'failed';
export type CompanyResultStatus = 'success' | 'failed';

export interface CompanyResult {
    companyId: string;
    companyName: string;
    status: CompanyResultStatus;
    projectId?: string;  // Present when status='success'
    error?: string;      // Present when status='failed'
}

export interface BulkCreateFinancialYearJobStatusDto {
    _id: string;
    jobId: string;
    userId: string;
    organizationId: string;
    status: JobStatus;
    totalCompanies: number;
    processedCompanies: number;
    successCount: number;
    failureCount: number;
    results: CompanyResult[];
    createdAt: string;
    updatedAt: string;
}
